/** Parse facility notification list keys (e.g. StateOnline → State + online). */
export const parseNotificationTypeKey = typeKey => {
  if (!typeKey) return {type: null, state: null};

  if (typeKey.includes("StateRemind")) {
    const state = typeKey.replace("StateRemind", "");
    return {type: "StateRemind", state: state || null};
  }

  if (typeKey.includes("State")) {
    const state = typeKey.replace("State", "");
    return {type: "State", state: state || null};
  }

  return {type: typeKey, state: null};
};

export const hasChecksheetFilter = type => type === "Remind" || type === "Overdue";

export const getEmptyPreviewKind = type => {
  if (type === "Overdue") return "overdue";
  if (type === "Remind") return "outstanding";
  return "matching";
};

export const buildNotificationPreviewPayload = ({
  facilityId,
  type,
  frequency = null,
  state = null,
  includeTags = false,
  filterChecksheets = false,
  checksheetIds = null
}) => {
  const payload = {
    facilityId,
    type,
    frequency: frequency || null
  };

  if (type === "Completed") payload.includeTags = !!includeTags;
  if (type === "State" || type === "StateRemind") payload.state = state || null;
  if (hasChecksheetFilter(type) && filterChecksheets)
    payload.checksheetIds = checksheetIds || [];

  return payload;
};

/** Build preview hook args from a published notification row. */
export const previewArgsFromNotification = ({typeKey, freq, notification, facilityId}) => {
  const {type, state} = parseNotificationTypeKey(typeKey);
  const freqNormalized = freq?.toLowerCase();
  const checksheetIds = notification?.checksheetIds?.length
    ? notification.checksheetIds.map(Number)
    : null;

  return {
    facilityId,
    type,
    frequency: freqNormalized && freqNormalized !== "none" ? freqNormalized : null,
    state: state ? state.toLowerCase() : null,
    includeTags: !!(notification?.tags?.length > 0),
    filterChecksheets: !!checksheetIds?.length,
    checksheetIds
  };
};
